export enum predefinedFiltersId {
  hideInactiveCodes = 1,
  potentiallyUntranslated = 2
}

export enum queryFilters {
  text = 'text',
  description = 'searchInDescription',
  longDescription = 'searchInLongDescription'
}

export enum filterId {
  includeInactiveCodes = 'includeInactiveCodes',
  potentiallyUntranslatedOnly = 'potentiallyUntranslatedOnly',
  query = 'query',
  codeId = 'id',
  codetable = 'codetable',
  language = 'language'
}

export const maxDescriptionLength = 254;
export const maxLongDescriptionLength = 4000;

export const excelExportFilename = 'export-code-descriptions';
